// Parent view of a child's exam schedule: child selector + reused student exam page.
import React, { useState } from 'react';
import ExamSchedulePage from '@/features/student/pages/ExamSchedulePage';
import { ChildSelector } from '../components/ChildSelector';

const ParentExamSchedulePage: React.FC = () => {
  const [childId, setChildId] = useState<string | null>(null);

  return (
    <div>
      <div className="px-6 pt-6">
        <ChildSelector onChildChange={setChildId} />
      </div>
      {childId && <ExamSchedulePage key={childId} studentId={childId} />}
    </div>
  );
};

export default ParentExamSchedulePage;
